import { api } from "@/lib/api";
import { LoadingOverlay } from "@mantine/core";
import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router";

const DocumentDownload = () => {
    const params: any = useParams();
    const [navigate, setNavigate] = useState(false);
    useEffect(() => {
        const fetchDocument = async () => {
            try {
                if(params.folder && params.file){
                    const result: any = await api.get(`document/download?containerName=${params.folder}&fileName=${params.file}`, {
                        responseType: 'blob'})
                    const fileName = params.file;
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(result);
                    downloadLink.download = fileName;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                    setNavigate(true);
                }
            } catch (error) {
                console.error("Error fetching document:", error);
                
            }
        }
        fetchDocument();
    }, [params])
    useEffect(() => {
        document.title = "Downloading Document - Guard Dog Real Estate Protection Service";
    }, []);
    return (
        <>
            <LoadingOverlay visible={true} overlayProps={{blur: 2, radius: 'sm'}} loaderProps={{size: 'xl'}}></LoadingOverlay>
            {navigate ? <Navigate to="/" /> : null}
        </>
    )
}
export default DocumentDownload;